import {
  useState,
  Children,
  forwardRef,
  isValidElement,
  ReactNode,
} from 'react'
import { path } from 'ramda'
import { InputProps } from 'components/Common/MasterComponents/Input'
import List from '../Select/List'
import Wrapper from '../Select/Wrapper'
import Input from './Input'

interface AutocompleteProps extends InputProps {
  children?: ReactNode
  onSelect?: (value: any) => void
}

export const Autocomplete = forwardRef<HTMLInputElement, AutocompleteProps>(
  (props, ref) => {
    const {
      children, // dropdown list items
      onSelect, //
      ...inputProps // props passed to Input component
    } = props

    const [activeRow, setActiveRow] = useState(-1)
    const [opened, setOpened] = useState(false)

    const isDisabled = inputProps.disabled || inputProps.readOnly

    const open = (val: boolean) => {
      setOpened(!isDisabled && val)
    }

    const handleSelect = (value: unknown) => {
      open(false)
      if (onSelect) onSelect(value)
    }

    const handleSelectActiveRow = () => {
      const value = path(
        [activeRow, 'props', 'value'],
        Children.toArray(children)
      )
      if (value) {
        handleSelect(value)
      }
    }

    const listVisible =
      opened &&
      !isDisabled &&
      children &&
      Children.toArray(children).filter(isValidElement).length > 0

    return (
      <Wrapper
        opened={opened}
        setOpen={open}
        onSelectActiveRow={handleSelectActiveRow}
        items={children}
        setActiveRow={setActiveRow}
      >
        <Input {...inputProps} opened={opened} setOpen={open} ref={ref} />
        {listVisible && (
          <List onSelect={handleSelect} activeItemIndex={activeRow}>
            {children}
          </List>
        )}
      </Wrapper>
    )
  }
)
